import React from 'react'

function Verify() {
    return (
        <h1>
            HELLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLO
        </h1>
    )
}

export default Verify
